export enum ClinicLocationDetailsTabType {
  CLINIC_LOCATION_INFO = 'clinic-location-info',
  PATIENTS = 'patients',
  PROVIDERS = 'providers',
}
